module.exports = __webpack_public_path__ + "img/coding.2ff72ec2.png";